
// import React, { useEffect } from 'react';
// import { Link, useNavigate, useLocation } from 'react-router-dom';
// import { FaMotorcycle, FaBell, FaUserFriends, FaWallet, FaFolderOpen } from 'react-icons/fa';

// function MProfileSideBar() {
//   const navigate = useNavigate(); 
//   const location = useLocation(); 

//   useEffect(() => {
//     if (location.pathname === '/profile') {
//       navigate('/profile/myprofile');
//     }
//   }, [location, navigate]);

//   const handleLogout = () => {
//     navigate('/logout');
//   };

//   return (
//     <div className="w-full max-w-sm bg-white rounded-lg shadow-lg p-6 mx-auto border ">
//       {/* Profile Section */}
//       <div className="flex flex-col items-center justify-center h-40 pb-4 mb-4 bg-gray-100">
//         <div className="w-16 h-16 rounded-full bg-gray-300 flex items-center justify-center text-white text-2xl font-semibold">
//           R
//         </div>
//         <h2 className="mt-2 font-semibold">Ranjita</h2>
//         <p className="text-sm text-gray-500">Name as per DL</p>
//       </div>

//       {/* Navigation Links */}
//       <div className="space-y-2">
//         <Link to="/m-profile" className="flex items-center p-2 hover:bg-[#FF9630] rounded cursor-pointer">
//           <FaUserFriends className="mr-3" />
//           <span className="flex-start font-normal">My Profile</span>
//           <span className="text-gray-400 ml-auto">›</span>
//         </Link>
//         <Link to="/m-myride" className="flex items-center p-2 hover:bg-[#FF9630] rounded cursor-pointer">
//           <FaMotorcycle className="mr-3" />
//           <span className="flex-start">My Ride</span>
//           <span className="text-gray-400 ml-auto">›</span>
//         </Link>
//         <Link to="/m-mybooking" className="flex items-center p-2 hover:bg-[#FF9630] rounded cursor-pointer">
//           <FaMotorcycle className="mr-3" />
//           <span className="flex-start">My Bookings</span>
//           <span className="text-gray-400 ml-auto">›</span>
//         </Link>
//         <Link to="/m-notification" className="flex items-center p-2 hover:bg-[#FF9630] rounded cursor-pointer">
//           <FaBell className="mr-3" />
//           <span className="flex-start">Notifications</span>
//           <span className="text-gray-400 ml-auto">›</span>
//         </Link>
//         <Link to="/m-myreferal" className="flex items-center p-2 hover:bg-[#FF9630] rounded cursor-pointer">
//           <FaUserFriends className="mr-3" />
//           <span className="flex-start">My Referrals</span>
//           <span className="text-gray-400 ml-auto">›</span>
//         </Link>
//         <Link to="/m-wallet-amt" className="flex items-center p-2 hover:bg-[#FF9630] rounded cursor-pointer">
//           <FaWallet className="mr-3" />
//           <span className="flex-start">Wallet</span>
//           <span className="text-gray-400 ml-auto">›</span>
//         </Link>
//         <Link to="/profile" className="flex items-center p-2 hover:bg-[#FF9630] rounded cursor-pointer">
//           <FaFolderOpen className="mr-3" />
//           <span className="flex-start">My Case</span>
//           <span className="text-gray-400 ml-auto">›</span>
//         </Link>
//       </div>

//       {/* Logout Button */}
//       <button
//         className="mt-4 w-full py-2 border rounded text-gray-600 hover:bg-gray-100"
//         onClick={handleLogout} // Handle click event
//       >
//         Logout
//       </button>
//     </div>
//   );
// }

// export default MProfileSideBar;


// import React, { useEffect } from 'react';
// import { Link, useNavigate, useLocation } from 'react-router-dom';
// import { FaMotorcycle, FaBell, FaUserFriends, FaWallet, FaFolderOpen } from 'react-icons/fa';
// import ProfileComponent from '../../MyProfile/MyProfile/ProfileComponent';
// function MProfileSideBar() {
//   const navigate = useNavigate(); 
//   const location = useLocation(); 

//   const [isCategoryModalOpen, setCategoryModalOpen] = useState(false);

//   const handleCategoryModalToggle = () => {
//     setCategoryModalOpen((prev) => !prev);
//   };

//   const handleCategorySelect = (selectedCategories) => {
//     setFormData((prevData) => ({
//       ...prevData,
//       category: selectedCategories.join(", "),
//     }));
//   };

//   useEffect(() => {
//     if (location.pathname === '/profile') {
//       navigate('/profile/myprofile');
//     }
//   }, [location, navigate]);

//   const handleLogout = () => {
//     navigate('/logout');
//   };

//   return (
//     <div className="w-full max-w-sm bg-white rounded-lg shadow-lg p-6 mx-auto border ">
//       {/* Profile Section */}
//       <div className="flex flex-col items-center justify-center h-40 pb-4 mb-4 bg-gray-100">
//         <div className="w-16 h-16 rounded-full bg-gray-300 flex items-center justify-center text-white text-2xl font-semibold">
//           R
//         </div>
//         <h2 className="mt-2 font-semibold">Ranjita</h2>
//         <p className="text-sm text-gray-500">Name as per DL</p>
//       </div>

//       {/* Navigation Links */}
//       <div className="space-y-2">
//       <ProfileComponent closeModal={handleCategoryModalToggle} />
//           <FaUserFriends className="mr-3" />
//           <span className="flex-start font-normal">My Profile</span>
//           <span className="text-gray-400 ml-auto">›</span>

//         <Link to="/m-myride" className="flex items-center p-2 hover:bg-[#FF9630] rounded cursor-pointer">
//           <FaMotorcycle className="mr-3" />
//           <span className="flex-start">My Ride</span>
//           <span className="text-gray-400 ml-auto">›</span>
//         </Link>
//         <Link to="/m-mybooking" className="flex items-center p-2 hover:bg-[#FF9630] rounded cursor-pointer">
//           <FaMotorcycle className="mr-3" />
//           <span className="flex-start">My Bookings</span>
//           <span className="text-gray-400 ml-auto">›</span>
//         </Link>
//         <Link to="/m-notification" className="flex items-center p-2 hover:bg-[#FF9630] rounded cursor-pointer">
//           <FaBell className="mr-3" />
//           <span className="flex-start">Notifications</span>
//           <span className="text-gray-400 ml-auto">›</span>
//         </Link>
//         <Link to="/m-myreferal" className="flex items-center p-2 hover:bg-[#FF9630] rounded cursor-pointer">
//           <FaUserFriends className="mr-3" />
//           <span className="flex-start">My Referrals</span>
//           <span className="text-gray-400 ml-auto">›</span>
//         </Link>
//         <Link to="/m-wallet-amt" className="flex items-center p-2 hover:bg-[#FF9630] rounded cursor-pointer">
//           <FaWallet className="mr-3" />
//           <span className="flex-start">Wallet</span>
//           <span className="text-gray-400 ml-auto">›</span>
//         </Link>
//         <Link to="/profile" className="flex items-center p-2 hover:bg-[#FF9630] rounded cursor-pointer">
//           <FaFolderOpen className="mr-3" />
//           <span className="flex-start">My Case</span>
//           <span className="text-gray-400 ml-auto">›</span>
//         </Link>
//       </div>

//       {/* Logout Button */}
//       <button
//         className="mt-4 w-full py-2 border rounded text-gray-600 hover:bg-gray-100"
//         onClick={handleLogout} // Handle click event
//       >
//         Logout
//       </button>
//     </div>
//   );
// }

// export default MProfileSideBar;

// import React, { useState, useEffect } from 'react';
// import { Link, useNavigate, useLocation } from 'react-router-dom';
// import { FaMotorcycle, FaBell, FaUserFriends, FaWallet, FaFolderOpen } from 'react-icons/fa';
// // import ProfileComponent from '../../MyProfile/MyProfile/ProfileComponent';

// function MProfileSideBar() {
//   const navigate = useNavigate();
//   const location = useLocation();

//   const [isModalOpen, setModalOpen] = useState(false);
//   const [modalContent, setModalContent] = useState('');

//   useEffect(() => {
//     if (location.pathname === '/profile') {
//       navigate('/profile/myprofile');
//     }
//   }, [location, navigate]);

//   const handleLogout = () => {
//     navigate('/logout');
//   };

//   const openModal = (content) => {
//     setModalContent(content);
//     setModalOpen(true);
//   };

//   const closeModal = () => {
//     setModalOpen(false);
//     setModalContent('');
//   };

//   return (
//     <div className="w-full max-w-sm bg-white rounded-lg shadow-lg p-6 mx-auto border">
//       {/* Profile Section */}
//       <div className="flex flex-col items-center justify-center h-40 pb-4 mb-4 bg-gray-100">
//         <div className="w-16 h-16 rounded-full bg-gray-300 flex items-center justify-center text-white text-2xl font-semibold">
//           R
//         </div>
//         <h2 className="mt-2 font-semibold">Ranjita</h2>
//         <p className="text-sm text-gray-500">Name as per DL</p>
//       </div>

//       {/* Navigation Links */}
//       <div className="space-y-2">
//         <div
//           className="flex items-center p-2 hover:bg-[#FF9630] rounded cursor-pointer"
//           onClick={() => openModal('My Profile')}
//         >
//           <FaUserFriends className="mr-3" />
//           <span className="flex-start font-normal">My Profile</span>
//           <span className="text-gray-400 ml-auto">›</span>
//         </div>

//         <div
//           className="flex items-center p-2 hover:bg-[#FF9630] rounded cursor-pointer"
//           onClick={() => openModal('My Ride')}
//         >
//           <FaMotorcycle className="mr-3" />
//           <span className="flex-start">My Ride</span>
//           <span className="text-gray-400 ml-auto">›</span>
//         </div>

//         <div
//           className="flex items-center p-2 hover:bg-[#FF9630] rounded cursor-pointer"
//           onClick={() => openModal('My Bookings')}
//         >
//           <FaMotorcycle className="mr-3" />
//           <span className="flex-start">My Bookings</span>
//           <span className="text-gray-400 ml-auto">›</span>
//         </div>

//         <div
//           className="flex items-center p-2 hover:bg-[#FF9630] rounded cursor-pointer"
//           onClick={() => openModal('Notifications')}
//         >
//           <FaBell className="mr-3" />
//           <span className="flex-start">Notifications</span>
//           <span className="text-gray-400 ml-auto">›</span>
//         </div>

//         <div
//           className="flex items-center p-2 hover:bg-[#FF9630] rounded cursor-pointer"
//           onClick={() => openModal('My Referrals')}
//         >
//           <FaUserFriends className="mr-3" />
//           <span className="flex-start">My Referrals</span>
//           <span className="text-gray-400 ml-auto">›</span>
//         </div>

//         <div
//           className="flex items-center p-2 hover:bg-[#FF9630] rounded cursor-pointer"
//           onClick={() => openModal('Wallet')}
//         >
//           <FaWallet className="mr-3" />
//           <span className="flex-start">Wallet</span>
//           <span className="text-gray-400 ml-auto">›</span>
//         </div>

//         <div
//           className="flex items-center p-2 hover:bg-[#FF9630] rounded cursor-pointer"
//           onClick={() => openModal('My Case')}
//         >
//           <FaFolderOpen className="mr-3" />
//           <span className="flex-start">My Case</span>
//           <span className="text-gray-400 ml-auto">›</span>
//         </div>
//       </div>

//       {/* Logout Button */}
//       <button
//         className="mt-4 w-full py-2 border rounded text-gray-600 hover:bg-gray-100"
//         onClick={handleLogout}
//       >
//         Logout
//       </button>

//       {/* Modal Component */}
//       {isModalOpen && (
//         <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center">
//           <div className="bg-white p-6 rounded-lg shadow-lg w-11/12 max-w-md">
//             <h3 className="text-lg font-semibold mb-4">{modalContent}</h3>
//             <button
//               className="w-full py-2 bg-[#FF9630] text-white rounded hover:bg-[#e08428]"
//               onClick={closeModal}
//             >
//               Close
//             </button>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// }

// export default MProfileSideBar;


// import React, { useState, useEffect } from 'react';
// import { useNavigate, useLocation } from 'react-router-dom';
// import { FaMotorcycle, FaBell, FaUserFriends, FaWallet, FaFolderOpen } from 'react-icons/fa';
// import ProfileComponent from './MyProfile/MProfileComponent';
// import MyRideBoth from './MyRide/MyRideBoth';
// import MobileMyBooking from './MyBookings/MobileMyBooking';
// import Notification from './Notifications/MobileNotification';
// import MobileMyReferal from './MyReferrals/MobileMyReferal';
// import MobileWalletAmount from './Wallet/MobileWalletAmout';
// import MobileMyCase from './MyCase/MobileMyCase';

// function MProfileSideBar() {
//   const navigate = useNavigate();
//   const location = useLocation();

//   const [isModalOpen, setModalOpen] = useState(false);
//   const [modalContent, setModalContent] = useState('');

//   useEffect(() => {
//     if (location.pathname === '/profile') {
//       navigate('/profile/myprofile');
//     }
//   }, [location, navigate]);

//   const handleLogout = () => {
//     navigate('/logout');
//   };

//   const openModal = (content) => {
//     setModalContent(content);
//     setModalOpen(true);
//   };

//   const closeModal = () => {
//     setModalOpen(false);
//     setModalContent('');
//   };

//   return (
//     <div className="w-full max-w-sm bg-white rounded-lg shadow-lg r mt-12 mx-auto border">
//       {/* Profile Section */}
//       <div className="flex flex-col items-center justify-center h-40 pb-4 mb-4 bg-gray-100">
//         <div className="w-16 h-16 rounded-full bg-gray-300 flex items-center justify-center text-white text-2xl font-semibold">
//           R
//         </div>
//         <h2 className="mt-2 font-semibold">Ranjita</h2>
//         <p className="text-sm text-gray-500">Name as per DL</p>
//       </div>
      
//       <div className="space-y-2 p-2">
//         <div
//           className="flex items-center p-2 hover:bg-[#FF9630] rounded cursor-pointer"
//           onClick={() => openModal('My Profile')}
//         >
//           <FaUserFriends className="mr-3" />
//           <span className="flex-start font-normal">My Profile</span>
//           <span className="text-gray-400 ml-auto">›</span>
//         </div>

//         <div
//           className="flex items-center p-2 hover:bg-[#FF9630] rounded cursor-pointer"
//           onClick={() => openModal('My Ride')}
//         >
//           <FaMotorcycle className="mr-3" />
//           <span className="flex-start">My Ride</span>
//           <span className="text-gray-400 ml-auto">›</span>
//         </div>

//         <div
//           className="flex items-center p-2 hover:bg-[#FF9630] rounded cursor-pointer"
//           onClick={() => openModal('My Bookings')}
//         >
//           <FaMotorcycle className="mr-3" />
//           <span className="flex-start">My Bookings</span>
//           <span className="text-gray-400 ml-auto">›</span>
//         </div>

//         <div
//           className="flex items-center p-2 hover:bg-[#FF9630] rounded cursor-pointer"
//           onClick={() => openModal('Notifications')}
//         >
//           <FaBell className="mr-3" />
//           <span className="flex-start">Notifications</span>
//           <span className="text-gray-400 ml-auto">›</span>
//         </div>

//         <div
//           className="flex items-center p-2 hover:bg-[#FF9630] rounded cursor-pointer"
//           onClick={() => openModal('My Referrals')}
//         >
//           <FaUserFriends className="mr-3" />
//           <span className="flex-start">My Referrals</span>
//           <span className="text-gray-400 ml-auto">›</span>
//         </div>

//         <div
//           className="flex items-center p-2 hover:bg-[#FF9630] rounded cursor-pointer"
//           onClick={() => openModal('Wallet')}
//         >
//           <FaWallet className="mr-3" />
//           <span className="flex-start">Wallet</span>
//           <span className="text-gray-400 ml-auto">›</span>
//         </div>

//         <div
//           className="flex items-center p-2 hover:bg-[#FF9630] rounded cursor-pointer"
//           onClick={() => openModal('My Case')}
//         >
//           <FaFolderOpen className="mr-3" />
//           <span className="flex-start">My Case</span>
//           <span className="text-gray-400 ml-auto">›</span>
//         </div>
//       </div>

//       {/* Logout Button */}
//       <button
//         className="mt-4 w-full py-4 border rounded text-gray-600 hover:bg-gray-100"
//         onClick={handleLogout}
//       >
//         Logout
//       </button>

//       {isModalOpen && (
//         <div className=" fixed inset-0 bg-black z-50 flex items-center justify-center h-auto ">
//           <div className="bg-white rounded-lg shadow-lg w-full h-full">
//             {modalContent === 'My Profile' && <ProfileComponent closeModal={closeModal} />}
//             {modalContent === 'My Ride' && <MyRideBoth closeModal={closeModal} />}
//             {modalContent === 'My Bookings' && <MobileMyBooking closeModal={closeModal} />}
//             {modalContent === 'Notifications' && <Notification closeModal={closeModal} />}
//             {modalContent === 'My Referrals' && <MobileMyReferal closeModal={closeModal} />}
//             {modalContent === 'Wallet' && <MobileWalletAmount closeModal={closeModal} />}
//             {modalContent === 'My Case' && <MobileMyCase closeModal={closeModal} />}
//           </div>
//         </div>
//       )}
//     </div>
//   );
// }

// export default MProfileSideBar;

import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { 
  FaMotorcycle, 
  FaBell, 
  FaUserFriends, 
  FaWallet, 
  FaFolderOpen, 
  FaAngleRight 
} from 'react-icons/fa';
import ProfileComponent from './MyProfile/MProfileComponent';
import MyRideBoth from './MyRide/MyRideBoth';
import MobileMyBooking from './MyBookings/MobileMyBooking';
import Notification from './Notifications/MobileNotification';
import MobileMyReferal from './MyReferrals/MobileMyReferal';
import MobileWalletAmount from './Wallet/MobileWalletAmout';
import MobileMyCase from './MyCase/MobileMyCase';

function MProfileSideBar() {
  const navigate = useNavigate();
  const location = useLocation();

  const [isModalOpen, setModalOpen] = useState(false);
  const [modalContent, setModalContent] = useState('');

  useEffect(() => {
    if (location.pathname === '/profile') {
      navigate('/profile/myprofile');
    }
  }, [location, navigate]);

  const handleLogout = () => {
    navigate('/logout');
  };

  const openModal = (content) => {
    setModalContent(content);
    setModalOpen(true);
  };

  const closeModal = () => {
    setModalOpen(false);
    setModalContent('');
  };

  return (
    <div className="w-full max-w-sm bg-white rounded-lg shadow-lg mt-12 mx-auto border">
      {/* Profile Section */}
      <div className="flex flex-col items-center justify-center h-40 pb-4 mb-4 bg-gray-100">
        <div className="w-16 h-16 rounded-full bg-gray-300 flex items-center justify-center text-white text-2xl font-semibold">
          R
        </div>
        <h2 className="mt-2 font-semibold">Ranjita</h2>
        <p className="text-sm text-gray-500">Name as per DL</p>
      </div>
      
      <div className="space-y-2 p-2">
        <div
          className="flex items-center p-2 hover:bg-[#FF9630] rounded cursor-pointer"
          onClick={() => openModal('My Profile')}
        >
          <FaUserFriends className="mr-3" />
          <span className="flex-start font-normal">My Profile</span>
          <FaAngleRight className="text-gray-400 ml-auto" />
        </div>

        <div
          className="flex items-center p-2 hover:bg-[#FF9630] rounded cursor-pointer"
          onClick={() => openModal('My Ride')}
        >
          <FaMotorcycle className="mr-3" />
          <span className="flex-start">My Ride</span>
          <FaAngleRight className="text-gray-400 ml-auto" />
        </div>

        <div
          className="flex items-center p-2 hover:bg-[#FF9630] rounded cursor-pointer"
          onClick={() => openModal('My Bookings')}
        >
          <FaMotorcycle className="mr-3" />
          <span className="flex-start">My Bookings</span>
          <FaAngleRight className="text-gray-400 ml-auto" />
        </div>

        <div
          className="flex items-center p-2 hover:bg-[#FF9630] rounded cursor-pointer"
          onClick={() => openModal('Notifications')}
        >
          <FaBell className="mr-3" />
          <span className="flex-start">Notifications</span>
          <FaAngleRight className="text-gray-400 ml-auto" />
        </div>

        <div
          className="flex items-center p-2 hover:bg-[#FF9630] rounded cursor-pointer"
          onClick={() => openModal('My Referrals')}
        >
          <FaUserFriends className="mr-3" />
          <span className="flex-start">My Referrals</span>
          <FaAngleRight className="text-gray-400 ml-auto" />
        </div>

        <div
          className="flex items-center p-2 hover:bg-[#FF9630] rounded cursor-pointer"
          onClick={() => openModal('Wallet')}
        >
          <FaWallet className="mr-3" />
          <span className="flex-start">Wallet</span>
          <FaAngleRight className="text-gray-400 ml-auto" />
        </div>

        <div
          className="flex items-center p-2 hover:bg-[#FF9630] rounded cursor-pointer"
          onClick={() => openModal('My Case')}
        >
          <FaFolderOpen className="mr-3" />
          <span className="flex-start">My Case</span>
          <FaAngleRight className="text-gray-400 ml-auto" />
        </div>
      </div>

      {/* Logout Button */}
      <button
        className="mt-4 w-full py-4 border rounded text-gray-600 hover:bg-gray-100"
        onClick={handleLogout}
      >
        Logout
      </button>

      {isModalOpen && (
        <div className="fixed inset-0 bg-black z-50 flex items-center justify-center h-auto">
          <div className="bg-white rounded-lg shadow-lg w-full h-full">
            {modalContent === 'My Profile' && <ProfileComponent closeModal={closeModal} />}
            {modalContent === 'My Ride' && <MyRideBoth closeModal={closeModal} />}
            {modalContent === 'My Bookings' && <MobileMyBooking closeModal={closeModal} />}
            {modalContent === 'Notifications' && <Notification closeModal={closeModal} />}
            {modalContent === 'My Referrals' && <MobileMyReferal closeModal={closeModal} />}
            {modalContent === 'Wallet' && <MobileWalletAmount closeModal={closeModal} />}
            {modalContent === 'My Case' && <MobileMyCase closeModal={closeModal} />}
          </div>
        </div>
      )}
    </div>
  );
}

export default MProfileSideBar;

